import {
  queryList,
  queryAddNewForm,
  queryAddEditForm,
  queryDeleteItem,
  queryEditItemForm,
  queryFormActivate,
  querySavePermission,
  queryListPermissions,
} from './service';

import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'processConfigForm',
  state: {
    newForm: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    listUserPermission: null,
    listPositionPermission: null,
    listUserGroupPermission: null,
    pagination: meta,
    select: 'id,isActive,name,description',
    paramsView: {
      select: 'id,isActive,name,description,internalName,isInitialForm,created,updated',
      expand: {
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
        process: { select: 'name' },
      },
    },
    paramsEdit: {
      select: 'id,isActive,name,description,internalName,isInitialForm',
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryForms',
          payload: response,
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewForm({ payload }, { put }) {
      yield put({
        type: 'addForm',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewForm',
          payload,
        });
      }
    },

    *editItemForm({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemForm, payload);
        yield put({
          type: 'editForm',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewForm({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewForm, payload.data);
        yield put({
          type: 'global/showNotificationsForm',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveForm',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditForm({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditForm, payload.data);
        yield put({
          type: 'global/showNotificationsForm',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveForm',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showFormsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveForm',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showForms${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemForm({ view }, { put }) {
      yield put({
        type: 'showEditItemForm',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryFormActivate, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /* try */
      }
    },

    *fetchListPermissions({ payload }, { call, put }) {
      try {
        const response = yield call(queryListPermissions, payload);
        yield put({
          type: 'queryPermission',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewPermission({ payload }, { put }) {
      yield put({
        type: 'addPermission',
        payload,
      });
    },

    *addListPermission({ payload }, { put }) {
      yield put({
        type: 'addListPermissions',
        payload,
      });
    },

    *deleteItemPermision({ payload }, { put }) {
      yield put({
        type: 'deleteItemPermisions',
        payload,
      });
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
    },

    *savePermission({ payload }, { call, put }) {
      try {
        yield call(querySavePermission, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'addPermission',
          payload: {
            state: false,
            item: null,
          },
        });
        yield put({
          type: 'hidePermission',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryForms(state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },

    addForm(state, { payload }) {
      return {
        ...state,
        newForm: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewForm(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editForm(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newPermission: false,
      };
    },

    saveForm(state, { payload }) {
      return {
        ...state,
        saveForm: payload,
        newForm: false,
        selectedItem: false,
      };
    },

    showEditItemForm(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    FormActive(state, { payload }) {
      return {
        ...state,
        list: _.map(state.list, (o) => {
          if (o.id === payload.id) {
            _.set(o, 'isActive', payload.state);
          }
          return o;
        }),
      };
    },

    addPermission(state, { payload }) {
      return {
        ...state,
        newPermission: payload.state,
        newForm: false,
        selectedItem: payload.item,
      };
    },

    queryPermission(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.map(payload.data, (l) => {
          return {
            ...l[payload.field],
            id: l[`${payload.field}Id`],
          };
        }),
      };
    },

    addListPermissions(state, { payload }) {
      return {
        ...state,
        [payload.name]: [...state[payload.name], payload.data],
      };
    },

    deleteItemPermisions(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.filter(state[payload.name], (l) => l.id !== payload.id),
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },

    hidePermission(state) {
      return {
        ...state,
        selectedItem: null,
        listUserPermission: null,
        listPositionPermission: null,
        listUserGroupPermission: null,
        formConfig: null,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newForm: false,
        selectedItem: null,
        view: null,
        listUserPermission: null,
        listPositionPermission: null,
        listUserGroupPermission: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
